class NewsGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initGallery();
  }

  initGallery() {
    if (!this.querySelector('.news-gallery')) {
      return;
    }

    const splide = new Splide(this.querySelector('.news-gallery'), {
      type: 'slide',
      speed: 800,
      arrows: true,
      perPage: 1,
      gap: '20px',
      pagination: false,
      keyboard: 'focused',
      padding: {
        right: '55px',
        left: 'var(--pageWidthPadding)',
      },
      mediaQuery: 'min',
      breakpoints: {
        768: {
          perPage: 2,
        },
        1024: {
          perPage: 3,
          padding: {
            right: '38px',
            left: 'var(--pageWidthPadding)',
          },
        },
      },
    });

    splide.mount();
  }
}

customElements.define('news-gallery', NewsGallery);
